type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};
export const BILLING_DASHBOARD_HEADERS: Header[] = [
  {
    key: "billingFor",
    label: "Process",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },
  {
    key: "clientName",
    label: "Client",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },
  {
    key: "clientContactFullName",
    label: "QME Doctor",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },
  {
    key: "clientTeamMemberFullName",
    label: "User",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },

  {
    key: "priority",
    label: "Priority",
    style: { width: "10%", minWidth: "120px" },
    sortable: true,
  },

  {
    key: "caseExamTypes",
    label: "Case Type",
    style: {
      width: "10%",
      minWidth: "280px",
      maxWidth: "200px",
    },
    sortable: true,
  },

  {
    key: "rateType",
    label: "Rate Type",
    style: { width: "10%", minWidth: "120px" },
    sortable: true,
  },

  {
    key: "rate",
    label: "Billing Rate",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },
  {
    key: "clientRate",
    label: "Client Rate",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },

  {
    key: "effectiveFrom",
    label: "Effective From",
    style: { width: "20%", minWidth: "160px" },
    sortable: true,
  },
  {
    key: "effectiveTo",
    label: "Effective To",
    style: { width: "20%", minWidth: "170px" },
    sortable: true,
  },
  {
    key: "status",
    label: "Status",
    style: { width: "10%", minWidth: "120px" },
    sortable: true,
  },
  {
    key: "lastUpdatedOn",
    label: "Last Updated On",
    style: { width: "8%", minWidth: "160px" },
    sortable: true,
  },
  {
    key: "actions",
    label: "Action",
    style: { width: "8%", minWidth: "120px" },
  },
];

export const BILLING_DASHBOARD_CASE_HEADERS: Header[] = [
  {
    key: "caseId",
    label: "Case ID",
    style: { width: "10%", minWidth: "180px" },
    sortable: true,
  },
  {
    key: "subjectFullName",
    label: "Patient Name",
    style: { width: "10%", minWidth: "180px" },
    sortable: true,
  },
  {
    key: "patientAccountNo",
    label: "Account No",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },

  // {
  //   key: "caseExamTypes",
  //   label: "Case Type",
  //   style: {
  //     width: "10%",
  //     minWidth: "280px",
  //     maxWidth: "200px",
  //   },
  //   sortable: true,
  // },

  {
    key: "billingFor",
    label: "User ",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },
  {
    key: "billingForUserRole",
    label: "Role ",
    style: { width: "10%", minWidth: "150px" },
    sortable: true,
  },

  {
    key: "rateType",
    label: "Rate Type",
    style: { width: "10%", minWidth: "120px" },
    sortable: true,
  },
  {
    key: "thresholdType",
    label: "Page / Line Threshold",
    style: { width: "10%", minWidth: "200px" },
    sortable: true,
  },
  {
    key: "currency",
    label: "Currency",
    style: { width: "10%", minWidth: "110px" },
    sortable: true,
  },

  {
    key: "status",
    label: "Status",
    style: { width: "10%", minWidth: "120px" },
    sortable: true,
  },
  {
    key: "lastUpdatedOn",
    label: "Last Updated On",
    style: { width: "10%", minWidth: "200px" },
    sortable: true,
  },
  {
    key: "modifiedByName",
    label: "Last Updated By",
    style: { width: "10%", minWidth: "200px" },
    sortable: true,
  },
  {
    key: "actions",
    label: "Action",
    style: { width: "8%", minWidth: "120px" },
  },
];

export const BILLING_STANDARD_CHARGES_DASHBOARD_HEADERS: Header[] = [
  {
    key: "standardChargeNote",
    label: "Charge Name",
    style: { width: "10%" },
    sortable: true,
  },
  {
    key: "priorityName",
    label: "Priority",
    style: { width: "10%" },
    sortable: true,
  },
  {
    key: "caseExamTypes",
    label: "Case / Exam Type",
    style: { width: "10%" },
    sortable: true,
  },
  {
    key: "formattedStandardChargeRate",
    label: "Base Rate",
    style: { width: "8%" },
    isNumeric: true,
  },
  {
    key: "formattedClientRateStandardChargeRate",
    label: "Client Rate",
    style: { width: "8%" },
    isNumeric: true,
  },
  {
    key: "status",
    label: "Status",
    style: { width: "8%" },
    sortable: true,
  },
  {
    key: "lastUpdated",
    label: "Last Updated On",
    style: { width: "10%" },
    sortable: true,
  },
  {
    key: "actions",
    label: "Action",
    style: { width: "5%" },
  },
];

export const BILLING_CONFIG_CHANGE_LOG: Header[] = [
  {
    key: "fieldLabelUpdated",
    label: "Field Updated",
    style: { width: "10%" },
  },
  {
    key: "oldValue",
    label: "Old Value",
    style: { width: "10%" },
  },
  {
    key: "newValue",
    label: "New Value",
    style: { width: "10%" },
  },
  {
    key: "changedByName",
    label: "Updated By",
    style: { width: "7%" },
  },
  {
    key: "changedOn",
    label: "Updated On",
    style: { width: "10%" },
  },
];

export const BILLINGCASE_CONFIG_CHANGE_LOG: Header[] = [
  {
    key: "fieldLabelUpdated",
    label: "Field Updated",
    style: { width: "10%" },
  },
  {
    key: "oldValue",
    label: "Old Value",
    style: { width: "10%" },
  },
  {
    key: "newValue",
    label: "New Value",
    style: { width: "10%" },
  },
  {
    key: "updatedByName",
    label: "Updated By",
    style: { width: "7%" },
  },
  {
    key: "updatedOn",
    label: "Updated On",
    style: { width: "10%" },
  },
];

export const TEAM_OVERRIDDEN_CONFIGURATION_HEADERS: Header[] = [
  { key: "teamName", label: "Team Name", style: { width: "10%" } },
  { key: "priorityName", label: "Client Name", style: { width: "8%" } },
  { key: "priorityName", label: "Priority", style: { width: "6%" } },
  { key: "CaseExamType", label: "Case / Exam Type", style: { width: "15%" } },
  { key: "rateType", label: "Rate Type", style: { width: "6%" } },
  { key: "currencyType", label: "Currency", style: { width: "6%" } },
  { key: "effectiveFrom", label: "Effective From", style: { width: "10%" } },
];

export const CASE_OVERRIDDEN_CONFIGURATION_HEADERS: Header[] = [
  { key: "caseId", label: "Case ID" },
  { key: "subjectFullName", label: "Patient Name" },
  { key: "patientAccountNo", label: "Account No" },
  { key: "caseReviewTypeDesc", label: "Case / Exam Type" },
  { key: "billingForUserRole", label: "Role/User" },
  { key: "rateType", label: "Rate Type" },
  { key: "currencyType", label: "Currency" },
  { key: "status", label: "Status" },
  { key: "modifiedDate", label: "Last Updated On" },
  { key: "modifiedByName", label: "Last Updated By" },
];

export const BILLING_FIELD_LABEL_MAP: Record<string, string> = {
  webroleid: "Billing",
  userid: "Billing",
  priorityid: "Case Priority",
  effectivestartdate: "Effective Date From",
  effectiveenddate: "Effective Date To",
  casetypeidcsv: "Case Type",
  examtypeidcsv: "Exam Type",
  ratetype: "Rate Type",
  currencytype: "Currency",
  ratetypeflatrate: "Rate Type",
  ratetypeflatrateperpage: "Rate Type",
  ispagethreshholdappl: "Threshold Apply on Pages",
  billingconfigstatusid: "Status",
  comments: "Comments",
  isactive: "Status",
  createdby: "Created By",
  createddate: "Created Date",
  modifiedby: "Modified By",
  modifieddate: "Modified Date",
  standardchargerate: "Amount",
  standardchargedesc: "Description",
  effectiveperiod: "Effective Period",
};
